<template>
  <FeedWrapper :action="action">
    <template v-slot:body="props">
      <div :key="props.index" class="slide">
        <div class="grid md:grid-cols-3 gap-5">
          <div
            v-for="record in props.item"
            :key="record.id"
            class="flex flex-col rounded-md shadow-sm overflow-hidden"
            :class="wrapperClass"
          >
            <a :href="record.uri" class="block flex-shrink-0">
              <ImageTag
                :paths="record.image"
                :alt="record.name"
                css-class="w-full"
              ></ImageTag>
            </a>
            <div class="pt-6 pr-6 pb-3 pl-6 flex flex-col">
              <div class="block">
                <a
                  :href="record.uri"
                  class="block mt-2 text-xl leading-7 font-semibold"
                  :class="headingClass"
                  v-text="record.name"
                ></a>
                <p
                  class="block my-3 text-base leading-6"
                  :class="excerptColor"
                  v-text="record.excerpt"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </FeedWrapper>
</template>

<script>
import ImageTag from '../../src/components/Tag/Image';
import FeedWrapper from '../../src/components/Widgets/FeedWrapper';
export default {
  name: 'SegmentedFeed',
  components: { ImageTag, FeedWrapper },
  props: {
    action: {
      type: String,
      required: true,
    },
    bg: {
      type: String,
      default: 'bg-white',
    },
    bgHover: {
      type: String,
      default: 'bg-gray-100',
    },
    headingColor: {
      type: String,
      default: 'text-gray-900',
    },
    headingColorHover: {
      type: String,
      default: 'text-secondary',
    },
    excerptColor: {
      type: String,
      default: 'text-gray-900',
    },
  },
  computed: {
    wrapperClass() {
      return this.bg + ' hover:' + this.bgHover;
    },
    headingClass() {
      return this.headingColor + ' hover:' + this.headingColorHover;
    },
  },
};
</script>
